<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m16.715 12.8651-1.5-1.5v-2.67003h1.5zm3.78 9.44-1.85-1.85c-.28.15-.59.24-.93.24 0 .55-.45 1-1 1s-1-.45-1-1h-6.00002c0 .55-.45 1-1 1s-1-.45-1-1c-1.1 0-2-.9-2-2v-11.00003c0-.05.02-.1.02-.15l-3.63-3.63 1.41-1.41 18.38002 18.38003zm-3.61-3.61-3.42-3.42v2.42h-1.5v-3.92l-1.75-1.75v5.67h-1.50002v-7.17l-1-1.00003v9.17003zm-3.42-10.00003h-.92l.92.92zm6.25-1v8.17003l-2-2v-6.17003h-6.17l-1.83002-1.83v-3.17c0-.55.45002-1 1.00002-1h4c.55 0 1 .45 1 1v3h2c1.1 0 2 .9 2 2zm-8.5-2h3v-2.5h-3z"
    />
  </svg>
</template>
